if (!customElements.get('doublejinx-text-tab-loader')) {
  customElements.define(
    'doublejinx-text-tab-loader',
    class DoubleJinxTextTabLoader extends HTMLElement {},
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const widget = document.querySelector('[data-dj-text-tab]');
  if (!widget) return;

  const trigger = widget.querySelector('[data-dj-text-tab-trigger]');
  const panel = widget.querySelector('[data-dj-text-tab-panel]');
  const closeButton = widget.querySelector('[data-dj-text-tab-close]');

  const open = () => {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    widget.classList.add('is-open');
  };

  const close = () => {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    widget.classList.remove('is-open');
  };

  trigger?.addEventListener('click', () => {
    if (panel.hidden) {
      open();
    } else {
      close();
    }
  });

  closeButton?.addEventListener('click', close);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  document.addEventListener('click', (event) => {
    if (!widget.contains(event.target)) close();
  });
});
